module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"appName":"TRAC19","helpLink":"Aiuto","homeLink":"Home","back":"Indietro"}}')
  delete Component.options._Ctor
}
